import { render, staticRenderFns } from "./PnlSinglePage.vue?vue&type=template&id=24e9cb4d&scoped=true"
import script from "./PnlSinglePage.vue?vue&type=script&lang=js"
export * from "./PnlSinglePage.vue?vue&type=script&lang=js"
import style0 from "./PnlSinglePage.vue?vue&type=style&index=0&id=24e9cb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9cb4d",
  null
  
)

export default component.exports